import { createContext } from "react";

type TokenContextType = {
  refreshToken: () => Promise<void>;
  isTokenValid: () => boolean;
  isReady: boolean;
  tokenRef: React.MutableRefObject<{ token?: string; timestamp?: Date }>;
};

const TokenContext = createContext<TokenContextType>({
  refreshToken: async () => {},
  isTokenValid: () => false,
  isReady: false,
  tokenRef: { current: {} },
});

export default TokenContext;
